import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { EllipsisVertical } from 'lucide-react-native'
import { colors, getMemberFullName } from '@chillout/core'
import { AvatarInfo } from '@chillout/ui'
import type { CashierMemberProfile } from '../home/useMemberSearch'

interface MemberInfoHeaderProps {
  member: CashierMemberProfile
  title?: string
  onMenuPress?: () => void
}

export function MemberInfoHeader({ member, title, onMenuPress }: MemberInfoHeaderProps) {
  const { t } = useTranslation()
  const fullName = getMemberFullName(member)

  return (
    <View className="px-6 pt-2 pb-4">
      <View className="flex-row items-center justify-between mb-4">
        <Text className="text-xl font-bold text-primary">
          {title ?? t('stampAwarding.memberFound')}
        </Text>
        {onMenuPress != null && (
          <Pressable
            accessibilityRole="button"
            accessibilityLabel={t('stampAwarding.memberMenuAccessibilityLabel')}
            hitSlop={8}
            onPress={onMenuPress}
          >
            <EllipsisVertical size={22} color={colors.text.secondary} strokeWidth={2} />
          </Pressable>
        )}
      </View>

      <AvatarInfo
        name={fullName ?? t('stampAwarding.unknownMember')}
        email={member.email ?? undefined}
        size={48}
      />

      <View className="border-t border-border mt-4" />
    </View>
  )
}
